
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11674',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11674",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.261",
  "data-fetching-client": "static-1.9517",
  "foundations-components": "static-1.7599",
  "foundations-components-legacy": "static-1.624",
  "foundations-theming": "static-1.4251",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7846",
  "hub-http-shared-msw-handlers": "static-1.9566",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11281",
  "I18n": "static-7.1581",
  "jasmine-runner": "static-1.6309",
  "marketplace-storefront-base": "static-1.11734",
  "quartz": "static-1.6784",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16490",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2703",
  "reporting-testing-lib": "static-1.8624",
  "settings-ui-lib": "static-1.12363",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6804",
  "ui-addon-i18n": "static-1.10984",
  "ui-addon-react-router-dom": "static-1.9385",
  "unified-auth": "static-1.269",
  "unified-auth-core-lib": "static-1.550",
  "usage-tracker": "static-1.7175",
  "usage-tracker-core": "static-1.7025",
  "customer-data-property-utils": "static-1.7919",
  "history": "static-4.47",
  "hub-http": "static-1.6057",
  "integrations-lib": "static-1.15553",
  "marketplace-ui-common": "static-1.19056",
  "property-management-iframe": "static-1.12498",
  "quartz-config": "static-1.562",
  "quartz-core": "static-1.6003",
  "quartz-routing": "static-1.214",
  "quick-fetch": "static-1.3776",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4477",
  "ts-schema": "static-1.3943",
  "ui-universal-auth": "static-1.8755",
  "UIComponents": "static-3.8228",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3267",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3061",
  "quartz-webpack": "static-1.3008",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3868",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4679",
  "foundations-theming-specialty": "static-1.1967",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9266",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5212",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1323",
  "ui-fonts": "static-1.543",
  "ui-images": "static-2.1107",
  "bend-plugin-foundations-theming": "static-1.2734",
  "foundations-theming-base": "static-1.3236",
  "stylex": "static-1.28",
  "HeadJS": "static-2.719",
  "hs-test-utils-bend-plugin": "static-1.2957",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4166",
  "ai-components-ui-library": "static-1.8459",
  "ai-rendering-library": "static-1.9421",
  "chirp-fetch": "static-1.1722",
  "connections-embed-lib": "static-1.694",
  "copilot-toolkit": "static-1.10631",
  "laboratory-lib": "static-3.6999",
  "marketplace-embed": "static-1.21572",
  "marketplace-ui-details": "static-1.8952",
  "marketplace-ui-reviews": "static-1.19012",
  "marketplace-ui-tracking": "static-1.13227",
  "sanitize-text": "static-1.7985",
  "ui-addon-video-player": "static-1.8536",
  "usage-tracker-multi": "static-1.5589",
  "usage-tracker-session-replay": "static-1.4861",
  "wootric-nps": "static-1.6823",
  "apollo-link-hub-http": "static-2.4491",
  "immer": "static-1.33",
  "immerable": "static-1.3994",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66691",
  "cssUtils": "static-1.745",
  "flux-actions": "static-1.312",
  "HubStyle": "static-2.11589",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10051",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10213",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7165",
  "icons": "static-2.627",
  "marketplace-ui-apps-core": "static-1.17589",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4360",
  "foundations-components-test-utils": "static-1.5082",
  "quartz-i18n": "static-1.459",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3570",
  "customer-data-objects": "static-1.7488",
  "property-translator": "static-1.5249",
  "frontend-preferences-client": "static-1.7764",
  "hs-promise-utils": "static-1.5433",
  "hubspot-apollo-client": "static-1.4719",
  "integrations-error-boundary-lib": "static-1.12968",
  "integrations-tracking-lib": "static-1.5428",
  "native-integrations-shared-strings": "static-1.7627",
  "reselect": "static-2.16",
  "sanitize": "static-1.4314",
  "superstore": "static-1.4609",
  "ui-shepherd-react": "static-3.9986",
  "ai-settings-ui-library": "static-1.7564",
  "hub-http-janus": "static-1.804",
  "hubspotter-http": "static-1.4516",
  "immutable-less": "static-1.4494",
  "marketplace-ui-client-types": "static-1.16463",
  "nav-meta": "static-1.29039",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10079",
  "ui-addon-upgrades": "static-9.17711",
  "inbound-db-properties-service-client": "static-1.3712",
  "property-management-common": "static-1.4785",
  "ui-addon-iframeable": "static-1.8887",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.492",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.459",
  "quartz-head": "static-1.449",
  "quartz-test": "static-1.459",
  "quartz-tracking": "static-1.163",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2988",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20485",
  "ContentUtils": "static-1.67736",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2330",
  "customer-data-filters-ui": "static-1.39045",
  "customer-data-objects-ui-components": "static-1.12851",
  "customer-data-reference-ui-components": "static-1.12987",
  "embedded-academy-lib": "static-1.13690",
  "ExportDialog": "static-6.10227",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40754",
  "reporting-snowflake": "static-1.55309",
  "reporting-ui-components": "static-2.63962",
  "reporting-visualizations": "static-1.58767",
  "ui-addon-teams": "static-1.21292",
  "magpie-lib": "static-1.5434",
  "magpie-types": "static-1.4894",
  "simple-logging-lib": "static-1.2890",
  "navigation-components": "static-1.17402",
  "ai-studio-lib": "static-1.11101",
  "developer-experience-shared-components": "static-1.10334",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7832",
  "ui-tool-access": "static-1.9984",
  "usage-based-billing-components-lib": "static-1.8113",
  "usage-tracker-anonymous": "static-1.5592",
  "usage-tracker-public": "static-1.6986",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3458",
  "persist-promise": "static-1.3548",
  "reference-resolvers": "static-1.8002",
  "ui-extensibility-client-types": "static-1.3783",
  "hubspot-apollo-cache": "static-1.178",
  "universal-page-editor-lib": "static-1.2838",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2289",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4910",
  "purchase-motions-components": "static-1.5530",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1391",
  "crm-component-utils": "static-1.38575",
  "crm-properties-common-lib": "static-1.5712",
  "customer-data-properties": "static-1.50881",
  "framework-data-schema-resolvers": "static-1.6712",
  "property-value-citations": "static-1.1495",
  "reference-resolvers-lite": "static-1.7923",
  "navigation-messaging": "static-1.6729",
  "hubspotter-http-shared-msw-handlers": "static-1.9564",
  "cms-field-types": "static-1.4648",
  "content-icons-ui": "static-1.2169",
  "conversations-skeleton-state": "static-1.7088",
  "crm-message-bus": "static-1.42480",
  "customer-data-filters-ui-msw-helpers": "static-1.21480",
  "customer-data-ui-utilities": "static-1.9664",
  "FormUrlGenerator": "static-2.4561",
  "framework-builder-read-service-client": "static-1.3871",
  "framework-data-schema-quick-fetch": "static-1.6617",
  "multi-account-reference-resolvers": "static-1.813",
  "onboarding-tours": "static-1.16318",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13171",
  "academy-common-lib": "static-1.13150",
  "content-assistance-lib": "static-1.7506",
  "dashboard-lib": "static-1.80787",
  "file-manager-components": "static-1.23016",
  "getting-started-shared-tasks": "static-1.17991",
  "hubspot-prosemirror": "static-1.17708",
  "hubspot-prosemirror-plugins": "static-1.17700",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19537",
  "share-with-third-party-component-lib": "static-1.8533",
  "ui-addon-draggable": "static-3.4606",
  "ui-asset-management-lib": "static-1.10760",
  "ui-business-units-lib": "static-1.8871",
  "user-context": "static-1.4940",
  "growth-payments-core": "static-1.24837",
  "reporting-plugins": "static-1.10025",
  "reporting-reports": "static-1.66369",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.565",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28942",
  "react-codemirror": "static-1.10466",
  "apps-service-types": "static-1.3717",
  "oauth-service-types": "static-1.4087",
  "onboarding-scopes": "static-1.6303",
  "onboarding-tours-client": "static-1.4532",
  "platform-infra-nav-components": "static-1.7529",
  "subscription-experience-data-types": "static-1.14631",
  "crm-record-cards-service-types": "static-1.3481",
  "location-customization-utils-lib": "static-1.8684",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4339",
  "nav-client-types": "static-1.2197",
  "purchase-motions-api": "static-1.5533",
  "signup-constants": "static-1.18500",
  "signup-ui-url-generator": "static-2.7874",
  "trials-service-types": "static-1.3740",
  "card-properties-lib": "static-1.43636",
  "commerce-subscription-lib": "static-1.36569",
  "crm-actions": "static-1.6145",
  "crm-cards-sdk": "static-1.43037",
  "customer-data-properties-shared-msw-handlers": "static-1.8893",
  "customer-data-tracking": "static-1.6722",
  "hs-entities": "static-1.520",
  "pulse": "static-1.356",
  "calling-global-api": "static-1.63809",
  "calling-internal-common": "static-1.31136",
  "calling-lifecycle-internal": "static-1.65191",
  "calling-lifecycle-messages": "static-1.57485",
  "commerce-products-lib": "static-1.8961",
  "conditional-properties-service-client": "static-1.3661",
  "crm-links": "static-1.6106",
  "external-options-client-types": "static-1.4022",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4086",
  "meetings-icalendar-utils-lib": "static-1.472",
  "multi-currency-client-types": "static-1.3554",
  "object-builder-ui-client": "static-1.48127",
  "pipeline-validation-client-types": "static-1.3827",
  "smart-property-lib": "static-1.6093",
  "tiered-pricing": "static-1.885",
  "ui-addon-form-validation": "static-1.10833",
  "crm-pipelines-api-client-types": "static-1.4003",
  "react-dnd-compat": "static-1.4460",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5198",
  "growth-onboarding-confetti": "static-1.2912",
  "growth-onboarding-next-action-utils": "static-1.1395",
  "onboarding-tours-utils": "static-1.384",
  "ui-shepherd-tracker": "static-1.7367",
  "academy-service-client": "static-1.3520",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28047",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8225",
  "video-components-external": "static-1.10684",
  "video-data-lib": "static-1.34342",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8407",
  "payment-link-components": "static-1.23043",
  "ui-addon-emoji-picker": "static-1.9727",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6878",
  "data-token-picker": "static-1.16109",
  "FileManagerLib": "static-1.38656",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5084",
  "getting-started-shared-tasks-store": "static-1.17109",
  "campaign-roi-lib": "static-1.8401",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.232",
  "eligibility-engine-service-types": "static-1.3021",
  "crm_data": "static-4.91374",
  "customer-data-sidebar": "static-2.45520",
  "enrichment-properties-lib": "static-1.15211",
  "commerce-billing-lib": "static-1.18600",
  "commerce-shared-components-lib": "static-1.18050",
  "commerce-tools-ui-lib": "static-1.9891",
  "crm-fe-perf": "static-1.22745",
  "directed-graph": "static-1.779",
  "event-emitter": "static-1.787",
  "calling-error-reporting": "static-1.31142",
  "shared-worker-versioning": "static-1.10879",
  "calling-usage-tracker": "static-1.6381",
  "voice-sms-access-library": "static-1.360",
  "commerce-permissions": "static-1.601",
  "products-iframe-lib": "static-1.7434",
  "products-ui-components-shared-msw-handlers": "static-1.9948",
  "breeze-intelligence-kit": "static-1.5379",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9649",
  "policy-lib": "static-1.6617",
  "react-tinymce": "static-1.54728",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9712",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53854",
  "tinymce-plugins": "static-1.56968",
  "tinymce-themes": "static-1.55824",
  "growth-onboarding-next-action-components": "static-1.1423",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6421",
  "content-media-composition-data-lib": "static-1.11588",
  "content-media-compositions": "static-2.15595",
  "media-bridge-lib": "static-1.18631",
  "commerce-tours-lib": "static-1.5774",
  "growth-onboarding-reliability": "static-1.4926",
  "sales-checkout-service-client": "static-1.3507",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21374",
  "sales-email-signature-service-client": "static-1.3683",
  "audio-components": "static-1.5669",
  "FileManagerCore": "static-1.38515",
  "FileManagerImages": "static-1.36167",
  "video-components": "static-1.12687",
  "crm_universal": "static-1.21725",
  "customer-data-email": "static-1.17736",
  "card-payment-highlight-lib": "static-1.36624",
  "card-subscription-highlight-lib": "static-1.38992",
  "commerce-contract-lib": "static-1.11340",
  "customer-data-content": "static-1.26940",
  "invoices-highlight-card-lib": "static-1.54156",
  "orders-highlight-card-lib": "static-1.20963",
  "products-highlight-card-lib": "static-1.17245",
  "project-storage": "static-1.4573",
  "quotes-highlight-card-lib": "static-1.71333",
  "crm-source-interpretation-lib": "static-1.5170",
  "utility-belt": "static-1.2380",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11507",
  "payments-enrollment-embed-lib": "static-1.22130",
  "customer-data-rte": "static-1.32537",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5426",
  "InboxConnectUtils": "static-4.14323",
  "payments-post-enroll-local-storage-lib": "static-1.4954",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37422",
  "calling-orchestration-schema": "static-1.35137",
  "sales-views-client-types": "static-1.4126",
  "hub-http-contrib": "static-1.2883",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39939",
  "ui-addon-sales-email": "static-1.5054",
  "layout-dnd-components": "static-1.12110",
  "layout-dnd-utils": "static-1.11085",
  "ui-brand-identity-lib": "static-1.14151",
  "NamespacedHubStyle": "static-2.8934",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4371",
  "video-embed": "static-1.35176",
  "social-insights-client-types": "static-1.21471",
  "sequences-lib": "static-1.7748",
  "ui-gdpr-components": "static-1.10187",
  "products-ui-components": "static-1.39480",
  "quotes-ui-lib": "static-1.80053",
  "SalesContentIndexUI": "static-3.8958",
  "accounting-integrations-ui-components": "static-1.6787",
  "invoices-ui-lib": "static-1.54172",
  "commerce-products-api": "static-1.2011",
  "SafeStorage": "static-1.4242",
  "invoices-iframe-lib": "static-1.56230",
  "quotes-modal-lib": "static-1.102010",
  "deal-intel-decorators": "static-1.1397",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7201",
  "draft-content-plugins": "static-1.27804",
  "ContentData": "static-1.67811",
  "layout-data-lib": "static-1.9410",
  "outpost": "static-1.4041",
  "sequences-client-types-lib": "static-1.7605",
  "commerce-tax-lib": "static-1.356",
  "property-description-translator": "static-1.3696",
  "FireAlarmUi": "static-1.4371",
  "sales-templates-service-types-lib": "static-1.4030",
  "commerce-analytics-service-client": "static-1.3495",
  "totals-ui-components": "static-1.23094",
  "deal-intel-utils": "static-1.1401",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14875",
  "advanced-menus-lib": "static-1.11845",
  "ui-memberships-settings-lib": "static-1.33554",
  "commerce-totals-service-types": "static-1.3678",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14874",
  "simple-menus-lib": "static-1.16391"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11674",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.261",
  "data-fetching-client": "/data-fetching-client/static-1.9517",
  "foundations-components": "/foundations-components/static-1.7599",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.624",
  "foundations-theming": "/foundations-theming/static-1.4251",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7846",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9566",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11281",
  "I18n": "/I18n/static-7.1581",
  "jasmine-runner": "/jasmine-runner/static-1.6309",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11734",
  "quartz": "/quartz/static-1.6784",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16490",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2703",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8624",
  "settings-ui-lib": "/settings-ui-lib/static-1.12363",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6804",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10984",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9385",
  "unified-auth": "/unified-auth/static-1.269",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.550",
  "usage-tracker": "/usage-tracker/static-1.7175",
  "usage-tracker-core": "/usage-tracker-core/static-1.7025",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7919",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6057",
  "integrations-lib": "/integrations-lib/static-1.15553",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19056",
  "property-management-iframe": "/property-management-iframe/static-1.12498",
  "quartz-config": "/quartz-config/static-1.562",
  "quartz-core": "/quartz-core/static-1.6003",
  "quartz-routing": "/quartz-routing/static-1.214",
  "quick-fetch": "/quick-fetch/static-1.3776",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4477",
  "ts-schema": "/ts-schema/static-1.3943",
  "ui-universal-auth": "/ui-universal-auth/static-1.8755",
  "UIComponents": "/UIComponents/static-3.8228",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3267",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3061",
  "quartz-webpack": "/quartz-webpack/static-1.3008",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3868",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4679",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1967",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9266",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5212",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1323",
  "ui-fonts": "/ui-fonts/static-1.543",
  "ui-images": "/ui-images/static-2.1107",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2734",
  "foundations-theming-base": "/foundations-theming-base/static-1.3236",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.719",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2957",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4166",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8459",
  "ai-rendering-library": "/ai-rendering-library/static-1.9421",
  "chirp-fetch": "/chirp-fetch/static-1.1722",
  "connections-embed-lib": "/connections-embed-lib/static-1.694",
  "copilot-toolkit": "/copilot-toolkit/static-1.10631",
  "laboratory-lib": "/laboratory-lib/static-3.6999",
  "marketplace-embed": "/marketplace-embed/static-1.21572",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8952",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19012",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13227",
  "sanitize-text": "/sanitize-text/static-1.7985",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8536",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5589",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4861",
  "wootric-nps": "/wootric-nps/static-1.6823",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4491",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3994",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66691",
  "cssUtils": "/cssUtils/static-1.745",
  "flux-actions": "/flux-actions/static-1.312",
  "HubStyle": "/HubStyle/static-2.11589",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10051",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10213",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7165",
  "icons": "/icons/static-2.627",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17589",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4360",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5082",
  "quartz-i18n": "/quartz-i18n/static-1.459",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3570",
  "customer-data-objects": "/customer-data-objects/static-1.7488",
  "property-translator": "/property-translator/static-1.5249",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7764",
  "hs-promise-utils": "/hs-promise-utils/static-1.5433",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4719",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12968",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5428",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7627",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4314",
  "superstore": "/superstore/static-1.4609",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9986",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7564",
  "hub-http-janus": "/hub-http-janus/static-1.804",
  "hubspotter-http": "/hubspotter-http/static-1.4516",
  "immutable-less": "/immutable-less/static-1.4494",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16463",
  "nav-meta": "/nav-meta/static-1.29039",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10079",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17711",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3712",
  "property-management-common": "/property-management-common/static-1.4785",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8887",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.492",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.459",
  "quartz-head": "/quartz-head/static-1.449",
  "quartz-test": "/quartz-test/static-1.459",
  "quartz-tracking": "/quartz-tracking/static-1.163",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2988",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20485",
  "ContentUtils": "/ContentUtils/static-1.67736",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2330",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39045",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12851",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12987",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13690",
  "ExportDialog": "/ExportDialog/static-6.10227",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40754",
  "reporting-snowflake": "/reporting-snowflake/static-1.55309",
  "reporting-ui-components": "/reporting-ui-components/static-2.63962",
  "reporting-visualizations": "/reporting-visualizations/static-1.58767",
  "ui-addon-teams": "/ui-addon-teams/static-1.21292",
  "magpie-lib": "/magpie-lib/static-1.5434",
  "magpie-types": "/magpie-types/static-1.4894",
  "simple-logging-lib": "/simple-logging-lib/static-1.2890",
  "navigation-components": "/navigation-components/static-1.17402",
  "ai-studio-lib": "/ai-studio-lib/static-1.11101",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10334",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7832",
  "ui-tool-access": "/ui-tool-access/static-1.9984",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8113",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5592",
  "usage-tracker-public": "/usage-tracker-public/static-1.6986",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3458",
  "persist-promise": "/persist-promise/static-1.3548",
  "reference-resolvers": "/reference-resolvers/static-1.8002",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3783",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.178",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2838",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2289",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4910",
  "purchase-motions-components": "/purchase-motions-components/static-1.5530",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1391",
  "crm-component-utils": "/crm-component-utils/static-1.38575",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5712",
  "customer-data-properties": "/customer-data-properties/static-1.50881",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6712",
  "property-value-citations": "/property-value-citations/static-1.1495",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "navigation-messaging": "/navigation-messaging/static-1.6729",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9564",
  "cms-field-types": "/cms-field-types/static-1.4648",
  "content-icons-ui": "/content-icons-ui/static-1.2169",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7088",
  "crm-message-bus": "/crm-message-bus/static-1.42480",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21480",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9664",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4561",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3871",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6617",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.813",
  "onboarding-tours": "/onboarding-tours/static-1.16318",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13171",
  "academy-common-lib": "/academy-common-lib/static-1.13150",
  "content-assistance-lib": "/content-assistance-lib/static-1.7506",
  "dashboard-lib": "/dashboard-lib/static-1.80787",
  "file-manager-components": "/file-manager-components/static-1.23016",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17991",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17708",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17700",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19537",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8533",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4606",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10760",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8871",
  "user-context": "/user-context/static-1.4940",
  "growth-payments-core": "/growth-payments-core/static-1.24837",
  "reporting-plugins": "/reporting-plugins/static-1.10025",
  "reporting-reports": "/reporting-reports/static-1.66369",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.565",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28942",
  "react-codemirror": "/react-codemirror/static-1.10466",
  "apps-service-types": "/apps-service-types/static-1.3717",
  "oauth-service-types": "/oauth-service-types/static-1.4087",
  "onboarding-scopes": "/onboarding-scopes/static-1.6303",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4532",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7529",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14631",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3481",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8684",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4339",
  "nav-client-types": "/nav-client-types/static-1.2197",
  "purchase-motions-api": "/purchase-motions-api/static-1.5533",
  "signup-constants": "/signup-constants/static-1.18500",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7874",
  "trials-service-types": "/trials-service-types/static-1.3740",
  "card-properties-lib": "/card-properties-lib/static-1.43636",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36569",
  "crm-actions": "/crm-actions/static-1.6145",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43037",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8893",
  "customer-data-tracking": "/customer-data-tracking/static-1.6722",
  "hs-entities": "/hs-entities/static-1.520",
  "pulse": "/pulse/static-1.356",
  "calling-global-api": "/calling-global-api/static-1.63809",
  "calling-internal-common": "/calling-internal-common/static-1.31136",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65191",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57485",
  "commerce-products-lib": "/commerce-products-lib/static-1.8961",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3661",
  "crm-links": "/crm-links/static-1.6106",
  "external-options-client-types": "/external-options-client-types/static-1.4022",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4086",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.472",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3554",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48127",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3827",
  "smart-property-lib": "/smart-property-lib/static-1.6093",
  "tiered-pricing": "/tiered-pricing/static-1.885",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10833",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4003",
  "react-dnd-compat": "/react-dnd-compat/static-1.4460",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5198",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2912",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1395",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.384",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7367",
  "academy-service-client": "/academy-service-client/static-1.3520",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28047",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8225",
  "video-components-external": "/video-components-external/static-1.10684",
  "video-data-lib": "/video-data-lib/static-1.34342",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8407",
  "payment-link-components": "/payment-link-components/static-1.23043",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9727",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6878",
  "data-token-picker": "/data-token-picker/static-1.16109",
  "FileManagerLib": "/FileManagerLib/static-1.38656",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5084",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17109",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8401",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.232",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3021",
  "crm_data": "/crm_data/static-4.91374",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45520",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15211",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18600",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18050",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9891",
  "crm-fe-perf": "/crm-fe-perf/static-1.22745",
  "directed-graph": "/directed-graph/static-1.779",
  "event-emitter": "/event-emitter/static-1.787",
  "calling-error-reporting": "/calling-error-reporting/static-1.31142",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10879",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6381",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.360",
  "commerce-permissions": "/commerce-permissions/static-1.601",
  "products-iframe-lib": "/products-iframe-lib/static-1.7434",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9948",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5379",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9649",
  "policy-lib": "/policy-lib/static-1.6617",
  "react-tinymce": "/react-tinymce/static-1.54728",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9712",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53854",
  "tinymce-plugins": "/tinymce-plugins/static-1.56968",
  "tinymce-themes": "/tinymce-themes/static-1.55824",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1423",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6421",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11588",
  "content-media-compositions": "/content-media-compositions/static-2.15595",
  "media-bridge-lib": "/media-bridge-lib/static-1.18631",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5774",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4926",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3507",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21374",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3683",
  "audio-components": "/audio-components/static-1.5669",
  "FileManagerCore": "/FileManagerCore/static-1.38515",
  "FileManagerImages": "/FileManagerImages/static-1.36167",
  "video-components": "/video-components/static-1.12687",
  "crm_universal": "/crm_universal/static-1.21725",
  "customer-data-email": "/customer-data-email/static-1.17736",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36624",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38992",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11340",
  "customer-data-content": "/customer-data-content/static-1.26940",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54156",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20963",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17245",
  "project-storage": "/project-storage/static-1.4573",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71333",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5170",
  "utility-belt": "/utility-belt/static-1.2380",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11507",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22130",
  "customer-data-rte": "/customer-data-rte/static-1.32537",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5426",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14323",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4954",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37422",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35137",
  "sales-views-client-types": "/sales-views-client-types/static-1.4126",
  "hub-http-contrib": "/hub-http-contrib/static-1.2883",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39939",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5054",
  "layout-dnd-components": "/layout-dnd-components/static-1.12110",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11085",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14151",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8934",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4371",
  "video-embed": "/video-embed/static-1.35176",
  "social-insights-client-types": "/social-insights-client-types/static-1.21471",
  "sequences-lib": "/sequences-lib/static-1.7748",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10187",
  "products-ui-components": "/products-ui-components/static-1.39480",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80053",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8958",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6787",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54172",
  "commerce-products-api": "/commerce-products-api/static-1.2011",
  "SafeStorage": "/SafeStorage/static-1.4242",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56230",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102010",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1397",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7201",
  "draft-content-plugins": "/draft-content-plugins/static-1.27804",
  "ContentData": "/ContentData/static-1.67811",
  "layout-data-lib": "/layout-data-lib/static-1.9410",
  "outpost": "/outpost/static-1.4041",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7605",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.356",
  "property-description-translator": "/property-description-translator/static-1.3696",
  "FireAlarmUi": "/FireAlarmUi/static-1.4371",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4030",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3495",
  "totals-ui-components": "/totals-ui-components/static-1.23094",
  "deal-intel-utils": "/deal-intel-utils/static-1.1401",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14875",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11845",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33554",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3678",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14874",
  "simple-menus-lib": "/simple-menus-lib/static-1.16391"
}
};
